import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAvailableBusApi } from "../../services/TransportService";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { convertTime } from "../../utilities";
import format from "date-fns/format";
import Select from "react-select";
import { searchshift } from "../../services/Reportservice";
import { searchroute } from "../../services/Reportservice";
import { getBusListSearchApi } from "../../services/SearchService";
const ListDetails = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [selecetdroute, setSelectedroute] = useState(null);
  const [selectedBus, setSelectedBus] = useState(null);
  const [selectedshift, setSelectedshift] = useState(null);
  const [busOption, setBusoption] = useState([]);
  const [shiftOption, setShiftoption] = useState([]);
  const [routeOption, setRouteoption] = useState([]);
  const [param, setParam] = useState({
    route_id: "",
    shift_id: "",
    bus_id: "",
    page: "1",
    page_size: "10",
  });
  useEffect(() => {
    getBusListSearchApi()
      .then((res) => {
        setBusoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    searchshift()
      .then((res) => {
        setShiftoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    searchroute()
      .then((res) => {
        setRouteoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    setParam({
      ...param,
      route_id: selecetdroute?.value || "",
      bus_id: selectedBus?.value || "",
      shift_id: selectedshift?.value || "",
    });
  }, [selecetdroute, selectedBus, selectedshift]);
  useEffect(() => {
    setLoading(true);
    getAvailableBusApi(param)
      .then((res) => {
        setData(res?.data?.results);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  const handlePagination = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  if (error) {
    return <div className="alert alert-danger m-2">{error}</div>;
  }
  return (
    <div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-2">
        <div>
          <span
            className="text-primary"
            style={{ fontSize: "1.3rem", fontWeight: "500" }}
          >
            Available Buses
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Available Buses
            </li>
          </ol>
        </div>
      </div>
      <div className="card mt-2">
        <div className="d-flex flex-column flex-sm-row justify-content-end gap-2 px-2 py-3">
          <div className="flex-fill flex-md-grow-0">
            <small>Select Route</small>
            <Select
              options={routeOption}
              onChange={setSelectedroute}
              placeholder="Select Route"
              className="react-select"
              classNamePrefix="select"
              isClearable
              value={selecetdroute}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 999,
                }),
              }}
            />
          </div>
          <div className="flex-fill flex-md-grow-0">
            <small>Select Bus</small>
            <Select
              options={busOption}
              onChange={setSelectedBus}
              placeholder="Select Route"
              className="react-select"
              classNamePrefix="select"
              isClearable
              value={selectedBus}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 999,
                }),
              }}
            />
          </div>
          <div className="flex-fill flex-md-grow-0">
            <small>Select Shift</small>
            <Select
              options={shiftOption}
              onChange={setSelectedshift}
              placeholder="Select Route"
              className="react-select"
              classNamePrefix="select"
              isClearable
              value={selectedshift}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 999,
                }),
              }}
            />
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : data?.length > 0 ? (
          <>
            <div className="table-responsive">
              <table class="table fs-6 mb-0">
                <thead class="table-light custom-thead">
                  <tr>
                    <th>Bus Number</th>
                    <th>Route</th>
                    <th>Shift</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Trip Mode</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    const tripModeClass =
                      item?.available_time[0]?.trip_mode?.toLowerCase() ===
                      "pickup"
                        ? "text-bg-success-soft"
                        : "text-bg-info-soft";
                    return (
                      <tr>
                        <td>
                          <Link
                            to={`/bus/${item?.bus?.id}`}
                            className="fw-medium text-primary cursor-pointer"
                          >
                            {item?.bus?.number_plate || "N/A"}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={`/route/${item?.route?.id}`}
                            className="fw-medium text-primary cursor-pointer"
                          >
                            {item?.route?.name || "N/A"}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={`/shift/${item?.shift?.id}`}
                            className="fw-medium text-primary cursor-pointer"
                          >
                            {item?.shift?.name || "N/A"}
                          </Link>
                        </td>
                        <td>
                          {item?.available_time[0]?.start_time
                            ? format(
                                convertTime(
                                  item?.available_time[0]?.start_time
                                ),
                                "hh:mm a"
                              )
                            : "N/A"}
                        </td>
                        <td>
                          {item?.available_time[0]?.end_time
                            ? format(
                                convertTime(item?.available_time[0]?.end_time),
                                "hh:mm a"
                              )
                            : "N/A"}
                        </td>
                        <td>
                          <span className={`badge ${tripModeClass}`}>
                            {item?.available_time[0]?.trip_mode || "N/A"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="text-center my-3">No Data Found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="border-top p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePagination}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListDetails;
